import React from "react"
// Import the image

const PageBanner = ({
  pageTitle,
  homePageUrl,
  homePageText,
  activePageText,
  image,
  pageTitleStyle,
  customImageAlt = "Evrchat growth engine", // Optional: Alt text for the image
}) => {
  return (
    <>
      <div className="page-title-area">
        <div className="container">
          <div className="page-title-content" style={{ display: "flex", alignItems: "center" }}>
            <h2 style={pageTitleStyle}>{pageTitle}</h2>
            {image && (
              <img src={image}
                alt={customImageAlt}
                style={{
                  maxHeight: "320px",
                }}
              />
            )}
          </div>
        </div>
        {/* Use the imported image in the src attribute */}
        
        {/* <div className="shape-img1">
          <img src={shape1} alt="banner" />
        </div> */}
        {/* <div className="shape-img2">
          <img src={shape2} alt="banner" />
        </div> */}
        {/* <div className="shape-img3">
          <img src={shape3} alt="banner" />
        </div> */}
      </div>
    </>
  )
}

export default PageBanner
